import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  font-size: 25px;
  color: white;
  padding: 10px;
  cursor: pointer;
  margin: 10px 10px;
  margin-top: 20px;
  font-family: "GothamPro", sans-serif;

  max-width: 100%;
  height: 35px;

  > svg {
    margin: 0 8px;
  }
`;
